<template>
    <base-select :label="model.caption" :options="options" v-model="currentValue" :select-type="selectType" :placeholder="param.placeholder" :display-value="displayValue" :required="param.required" @display-change="handleDisplayChange" :readonly="param.readonly" :disabled="param.disabled" :search="param.search" ref="select" :titlewidth="titlewidth" :textalign="textalign"></base-select>
</template>
<script>
import baseSelect from '../baseComponents/baseSelect/baseSelect.vue';
export default {

    name: 'emSelect',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: { default: '' },
        displayValue: { default: '' },
        options: {
            type: Array,
            default: function() {
                return [];
            }
        },
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },
    data() {
        return {
            currentValue: this.value
        };
    },
    computed: {
        param() {
            return this.model.initParam;
        },
        selectType() {
            if (this.model.xtype === 'select') {
                return 'select';
            }
            if (this.model.xtype === 'multi-select' || this.model.xtype === 'multi-select2') {
                return 'multi-select';
            }
        }
    },

    watch: {
        value(val) {
            this.currentValue = val;
        },
        currentValue(val) {
            this.$emit('input', val);
        }
    },
    created(){
        //debugger
        console.log(this)
    },
    methods: {
        handleDisplayChange(val) {
            this.$emit('update:displayValue', val);
        }
    },

    components: {
        baseSelect
    }
}
</script>
<style lang="css">
</style>


// WEBPACK FOOTER //
// emSelect.vue?0b95e7d4